import * as React from 'react'
import { SVGProps } from 'react'
import PropTypes from 'prop-types'
interface SVGRProps {
    title?: string;
    titleId?: string;
}
function SvgHelp({
    title,
    titleId,
    ...props
}: SVGProps<SVGSVGElement> & SVGRProps) {
    return (
        <svg
            viewBox="0 0 48 48"
            fill="currentColor"
            xmlns="http://www.w3.org/2000/svg"
            aria-labelledby={titleId}
            {...props}
        >
            {title ? <title id={titleId}>{title}</title> : null}
            <path d="M23.666 35.225a2.425 2.425 0 1 1 0-4.85 2.425 2.425 0 0 1 0 4.85ZM26.254 25.395c-.59.257-.97.839-.97 1.482a1.617 1.617 0 1 1-3.234 0 4.85 4.85 0 0 1 2.91-4.446 3.234 3.234 0 1 0-4.527-2.963 1.617 1.617 0 1 1-3.234 0 6.468 6.468 0 1 1 9.055 5.928v-.002Z" />
        </svg>
    )
}
SvgHelp.propTypes = {
    title: PropTypes.string,
    fill: PropTypes.string,
    width: PropTypes.string,
    height: PropTypes.string,
    stroke: PropTypes.string,
    color: PropTypes.string,
}
export default SvgHelp
